import { RootState } from "@/store/dtm";
import { addressType } from "@/types/addressType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface employmentInfo {
    displayId: string,
    id: number,
    status: string,
    type: string,
    occupation: string,
    occupationIndustry : string,
    jobTitle: string,
    ownershipType: string,
    businessType: string,
    industryYears: number | undefined,
    industryMonths: number | undefined,
    employmentYears: number | undefined,
    employmentMonths: number | undefined,
    notWorkingYears: number | undefined,
    notWorkingMonths: number | undefined,

    employerName: string,
    employerPhone: string,
    employerAddress: employerAddressInfo,
    manualAddressEntered: boolean,
}

export interface employerAddressInfo extends addressType {
    displayId: string,
}

export interface previousEmploymentState {
    employments: employmentInfo[]
    noPreviousEmployment?: boolean
}

const initialState: previousEmploymentState = {
    employments: [],
    noPreviousEmployment: false
}


export const previousEmploymentSlice = createSlice({
    name: "previousEmployment",
    initialState,
    reducers: {
        addPreviousEmployment: (state, action: PayloadAction<employmentInfo>) => {
            const employment = action.payload;
            state.employments.push(employment);
        },
        setEmploymentInfo:  (state, action: PayloadAction<employmentInfo>) => {
            const empInfo = action.payload;
            state.employments = state.employments.map(emp => emp.displayId == empInfo.displayId ? empInfo : emp);
        },
        removePreviousEmployment: (state, action: PayloadAction<string>) => {
            const id = action.payload;
            state.employments = state.employments.filter(employment => employment.displayId != id);

            //Reset the displayId of remaining employments
            state.employments = state.employments.map((employment, index) => ({
                ...employment,
                displayId: `${index + 1}`
            }));
        },
        toggleNoPreviousEmployment: (state, action: PayloadAction<boolean>) => {
            state.noPreviousEmployment = action.payload;
        },
        clearPreviousEmploymentState: (state) => {
            state.employments = []
            state.noPreviousEmployment = false;
        }
    }
});

export const { addPreviousEmployment, setEmploymentInfo, removePreviousEmployment, toggleNoPreviousEmployment, clearPreviousEmploymentState } = previousEmploymentSlice.actions

export default previousEmploymentSlice.reducer

export const selectPreviousEmployment = (state: RootState) => state.previousEmployment;